export const IQHUB_VERSION_REQ = 'IQHUB_VERSION_REQ'
export const IQHUB_VERSION_SUCCESS = 'IQHUB_VERSION_SUCCESS'
export const IQHUB_VERSION_ERROR = 'IQHUB_VERSION_ERROR'
export const IQHUB_VERSION_SET = 'IQHUB_VERSION_SET'

export const IQ_PORTAL_VERSION_REQ = 'IQ_PORTAL_VERSION_REQ'
export const IQ_PORTAL_VERSION_SET = 'IQ_PORTAL_VERSION_SET'
export const IQ_PORTAL_VERSION_SUCCESS = 'IQ_PORTAL_VERSION_SUCCESS'
export const IQ_PORTAL_VERSION_ERROR = 'IQ_PORTAL_VERSION_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/version/version.type.js